import { useEffect, useState } from "react";

// Client-only draft persistence (§B6 / 09 E5+H3): an unsubmitted text draft is mirrored into
// sessionStorage keyed by the player-session + step, so a reload or rejoin in the same tab
// lands the player back on their in-progress text rather than an empty field. Purely a client
// convenience - the authoritative value is still the payload; the draft just wins while it
// exists (unsaved local edits), falling back to the server value.

export const draftKey = (session, step) => {
  const id = (session && (session.recoveryCode || session.id)) || "anon";
  return `topik-draft:${id}:${step}`;
};

const read = (key) => {
  try {
    return key ? window.sessionStorage.getItem(key) : null;
  } catch (e) {
    return null;
  }
};

const write = (key, value) => {
  try {
    if (key) window.sessionStorage.setItem(key, value);
  } catch (e) {
    // sessionStorage can be unavailable (private mode / disabled) - drafts are best-effort.
  }
};

export const useDraft = (key, serverValue = "") => {
  const [value, setValue] = useState(() => {
    const stored = read(key);
    return stored != null ? stored : (serverValue || "");
  });

  useEffect(() => {
    write(key, value);
  }, [key, value]);

  return [value, setValue];
};
